import React from 'react';
import { Responsive, WidthProvider } from 'react-grid-layout';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import 'react-grid-layout/css/styles.css';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    color: theme.palette.secondary.contrastText,
    backgroundColor: theme.palette.secondary.main,
  },
}));

const DashboardGrid = ({ onLayoutChange, renderedWidgets, onModifyHandler }) => {
  const classes = useStyles();

  const handleResize = (layout, oldItem, newItem) => {
    onModifyHandler({ oldItem, newItem });
  };
  const ResponsiveGridLayout = WidthProvider(Responsive);
  return (
    <>
      <ResponsiveGridLayout
        breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 }}
        cols={{ lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 }}
        onLayoutChange={onLayoutChange}
        useCSSTransforms={false}
        rowHeight={30}
        width={1200}
        onResizeStop={handleResize}
        onDragStop={handleResize}
      >
        {renderedWidgets}
      </ResponsiveGridLayout>
    </>
  );
};

export default DashboardGrid;
